export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11502.1cb2a80d.jpg";